import React from 'react';
import { connect } from 'react-redux';
import {
  salesPageRequest,
  changeDateSalesSummary,
  changeOutletSalesSummary,
  exportSummary,
} from 'actions/reports/sales';
import { csvName } from 'utils/formatterCsvName';
import moment from 'moment';
import { formValueSelector } from 'redux-form';
import LoadingSpinner from 'components/LoadingSpinner';
import * as clevertapReportsSummary from 'clevertap/reports/summary';
import { getFormattedTime, getFormattedEndDate } from 'utils/hourFilter';
import withFeatureFlags from 'hocs/withFeatureFlags';
import ActionBar from '../ActionBar';
import styles from './ReportSummary.css';
import ReportSummaryTable from './ReportSummaryTable';
import BodyFrame from '../BodyFrame';

const exportMenus = [
  {
    display: 'Sales Summary Per Outlet',
    key: 'perOutlet',
    id: 'export-per-outlet',
  },
  {
    display: 'Sales Summary',
    key: 'salesSummary',
  },
];

class ReportSummary extends React.Component {
  componentDidMount() {
    this.props.dispatch(salesPageRequest());
  }

  render() {
    const { showLoadingSpinnerReport } = this.props.data.reports.sales;
    const { outlets, search, outletComparisonEnabled } = this.props;
    const hasMultipleOutlets = outlets && outlets.length > 1;
    const oneOutletSelected = search.outlet && search.outlet.length === 1;

    return (
      <div id="reports-sales-summary" className={styles.wrapper}>
        <ActionBar
          onChangeDate={this._onChangeDate}
          onChangeOutlet={this._onChangeOutlet}
          onExport={this._onClickExport}
          exportMenus={
            hasMultipleOutlets && oneOutletSelected && outletComparisonEnabled
              ? exportMenus
              : []
          }
          showExportFtue={hasMultipleOutlets && !!search.outlet}
        />
        <BodyFrame location={this.props.location}>
          <div className={styles['table-wrapper']}>
            <LoadingSpinner showLoadingSpinner={showLoadingSpinnerReport} />
            {!showLoadingSpinnerReport && <ReportSummaryTable />}
          </div>
        </BodyFrame>
      </div>
    );
  }

  _onChangeOutlet = (outletIds = []) => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeOutletSalesSummary({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      })
    );
  };

  _onChangeDate = ({ startDate, endDate, startHour, endHour, allDay }) => {
    const { outlet } = this.props.search;
    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    this.props.dispatch(
      changeDateSalesSummary(formattedStart, formattedEnd, outlet)
    );
  };

  _onClickExport = reportType => {
    const {
      startDate,
      endDate,
      startHour,
      endHour,
      allDay,
    } = this.props.search.date;
    const { outlet } = this.props.search;
    const { outlets } = this.props;

    let outletIds = outlet;
    if (reportType === 'perOutlet') {
      outletIds = outlets && outlets.map(o => o.id);
    }

    const { formattedStart, formattedEnd } = getFormattedTime(
      startDate,
      endDate,
      startHour,
      endHour,
      allDay
    );
    const filename = csvName(
      moment(formattedStart),
      moment(formattedEnd),
      'Report Sales Summary',
      outletIds,
      outlets,
      allDay
    );

    if (outletIds.length > 1 && this.props.outletComparisonEnabled) {
      clevertapReportsSummary.reportSummaryPerOutletExport({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    } else {
      clevertapReportsSummary.summaryExport({
        outletIds,
        startDate: formattedStart,
        endDate: formattedEnd,
      });
    }

    const query = {
      startDate: formattedStart,
      endDate: getFormattedEndDate(formattedEnd),
      timeZone: '',
    };
    const queryParams = {
      compareOutlet: this.props.outletComparisonEnabled,
    };
    this.props.dispatch(exportSummary(query, filename, outletIds, queryParams));
  };
}

const selector = formValueSelector('search');

function select(state) {
  return {
    outlets: state.actionBar.outlets,
    search: {
      outlet: selector(state, 'outlet'),
      date: selector(state, 'date'),
    },
    data: {
      reports: {
        sales: state.reports.sales,
      },
    },
  };
}

function mapFlagsToProp(flags) {
  return {
    outletComparisonEnabled: flags.summaryPerOutlet,
  };
}

export default withFeatureFlags(mapFlagsToProp)(connect(select)(ReportSummary));
